import { render, staticRenderFns } from "./MenuIconButton.vue?vue&type=template&id=115042d8&scoped=true&"
import script from "./MenuIconButton.vue?vue&type=script&lang=ts&"
export * from "./MenuIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./MenuIconButton.vue?vue&type=style&index=0&id=115042d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115042d8",
  null
  
)

export default component.exports